import React from 'react'
import jsonp from 'jsonp'
import toQueryString from 'to-querystring'
import './style.sass'

const getAjaxUrl = url => url.replace('/post?', '/post-json?')

class MailchimpSubscribe extends React.Component {
  state = {
    status: null,
    message: null,
  }
  subscribe = data => {
    const params = toQueryString(data)
    const url = getAjaxUrl(this.props.url) + '&' + params
    this.setState(
      {
        status: 'sending',
        message: null,
      },
      () =>
        jsonp(
          url,
          {
            param: 'c',
          },
          (err, data) => {
            if (err) {
              this.setState({
                status: 'error',
                message: err,
              })
            } else if (data.result !== 'success') {
              this.setState({
                status: 'error',
                message: data.msg,
              })
            } else {
              this.setState({
                status: 'success',
                message: data.msg,
              })
            }
          }
        )
    )
  }
  render() {
    return this.props.render({
      subscribe: this.subscribe,
      status: this.state.status,
      message: this.state.message,
    })
  }
}

MailchimpSubscribe.defaultProps = {
  render: ({ subscribe, status, message }) => (
    <SimpleForm
      status={status}
      message={message}
      onSubmitted={formData => subscribe(formData)}
    />
  ),
}

// a basic form
const SimpleForm = ({ status, message, className, style, onSubmitted }) => {
  let input
  const submit = () =>
    input &&
    input.value.indexOf('@') > -1 &&
    onSubmitted({
      EMAIL: input.value,
    })

  return (
    <div className={className} style={style}>
      {status === 'sending' && (
        <div className="Mailchimp__Messaggio">Caricamento...</div>
      )}
      {status === 'error' && (
        <div
          className="Mailchimp__Messaggio"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      {status === 'success' && (
        <div
          className="Mailchimp__Messaggio"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      <input ref={node => (input = node)} type="email" placeholder="Email" />
      <button onClick={submit}>Invia</button>
    </div>
  )
}

export default MailchimpSubscribe



// WEBPACK FOOTER //
// ./src/components/mailchimp-subscribe/index.js